
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { CloverComponent, ReplaceSpacesPipe } from './clover.component';
import { CloverRoutingModule } from './clover-routing.module';
import { SwiperModule } from 'swiper/angular';

import { RouterModule } from '@angular/router';
import { BannerTypeBModule } from 'src/app/components/banner-typeb/banner-typeb.module';
import { BlockTextModule } from 'src/app/components/block-text-img/block-text-img.module';
import { PromotionBannerModule } from 'src/app/components/promotion-banner/promotion-banner.module';
import { CarouselComponentModule } from 'src/app/components/carousel/carousel.module';
import { ButtonComponentModule } from 'src/app/components/button/button.module';
import { PlaylistModule } from 'src/app/components/playlist-videos/playlist.module';


@NgModule({
    declarations: [
        CloverComponent,
        ReplaceSpacesPipe
    ],
    imports: [
        CommonModule,
        CloverRoutingModule,
        SwiperModule,
        LazyLoadImageModule,
        RouterModule,
        BannerTypeBModule,
        BlockTextModule,
        PromotionBannerModule,
        CarouselComponentModule,
        ButtonComponentModule,
        PlaylistModule,
       

    ]
})
export class CloverModule { }


